/**
 * A same-origin path to return to after sign-in, or null. Rejects absolute and
 * protocol-relative URLs (`https://evil.test`, `//evil.test`, `/\evil.test`) so
 * a `?returnTo=` on the login page can never be turned into an open redirect.
 */
export function safeReturnTo(value: string | null | undefined): string | null {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
    return null;
  }
  return value;
}
